import React, { useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useState } from "react";
import { SEOHelmet } from '../../hooks/useSEO';

import { FaAngleDoubleRight } from "react-icons/fa";
import rabbit from "../../assets/blogpages/2x/Asset 84@2x.png";
import dog from "../../assets/blogpages/2x/Asset 72@2x.png";
import activity1 from "../../assets/blogpages/2x/Asset 34@2x.png";
import activity2 from "../../assets/blogpages/2x/Asset 91@2x.png";
import finalElephant from "../../assets/blogpages/2x/Asset 71@2x.png";
import safiaElephant from "../../assets/blogpages/2x/Asset 73@2x.png";
import { Link, useParams, useNavigate } from "react-router-dom";

import TheChallenge from "../../assets/blogpages/2x/Asset 97@2x.png";
import Whattodo from "../../assets/blogpages/2x/Asset 95@2x.png";
import Whatnottodo from "../../assets/blogpages/2x/Asset 93@2x.png";
import activitycard from "../../assets/blogpages/2x/Asset 94@2x.png";
import whatchlearn from "../../assets/blogpages/2x/Asset 96@2x.png";
import board from "../../assets/blogpages/2x/Asset 90@2x.png";



import Linkdin from "../../assets/blogpages/2x/Asset 70@2x.png";
import youtube from "../../assets/blogpages/2x/Asset 80@2x.png";
import facebook from "../../assets/blogpages/2x/Asset 81@2x.png";
import instaIcon from "../../assets/blogpages/2x/Asset 69@2x.png";
import Pinterest from "../../assets/blogpages/2x/Asset 83@2x.png";
import share from "../../assets/blogpages/2x/Asset 78@2x.png";
import thumbnail from "../../assets/blogpages/2x/Asset 99@2x.png";
import bell from "../../assets/blogpages/2x/Asset 75@2x.png";
import weeklyActivity from "../../assets/blogpages/2x/Asset 74@2x.png";
import kidsStory from "../../assets/blogpages/2x/Asset 88@2x.png";
import kidsSong from "../../assets/blogpages/2x/Asset 86@2x.png";
import kidslearning from "../../assets/blogpages/2x/Asset 85@2x.png";



import boardimg from "../../assets/blogs/2x/Asset 25@2x.png";
import elephantImg from "../../assets/blogs/2x/Asset 22@2x.png";
import cowImg from "../../assets/blogs/2x/Asset 31@2x.png";
import lionImg from "../../assets/blogs/2x/Asset 29@2x.png";
import deerImg from "../../assets/blogs/2x/Asset 30@2x.png";
import turtleImg from "../../assets/blogs/2x/Asset 28@2x.png";
import elephiImg from "../../assets/blogs/2x/Asset 32@2x.png";
import geassdivImg from "../../assets/blogs/2x/Asset 23@2x.png";
import blog1Img from "../../assets/blogs/2x/Asset 24@2x.png";
import styles from "./JungleMoralsUI.module.css"






const HelpingKidsLearnHowImportantTeamworkIs = () => {

    const { slug } = useParams(); // ✅ slug receive karo
    // const navigate = useNavigate();

    // ✅ Blog data ko slug se match karo (optional - agar dynamic content chahiye)
    const blogData = {
        "helping-kids-learn-how-important-teamwork-is": {
            title: "Helping Kids Learn How Important Teamwork Is",
            date: "07 January 2026",
            readTime: "4 min read"
        },
    };

    const currentBlog = blogData[slug] || {
        title: "Blog Not Found",
        date: "",
        readTime: ""
    };



    const blogPost = [
        {
            id: 1,
            title: "Kids Story",
            animal: "elephant",
            animalImg: elephantImg,
            image: kidsStory,
            youtubeLink: "https://youtube.com/playlist?list=PLaxSLMAewZhe0fLTty3heC6A5SjcIOFDT&si=QgY1RSUjanECb9et" // Apna link yahan daalo
        },
        {
            id: 2,
            title: "Kids Song",
            animal: "cow",
            animalImg: cowImg,
            image: kidsSong,
            youtubeLink: "https://youtube.com/playlist?list=PLaxSLMAewZhcH5rFX5FKeYqHjxlW8KEae&si=KgvZK7t6ojpc_wCw"
        },
        {
            id: 3,
            title: "Kids Learning",
            animal: "lion",
            animalImg: lionImg,
            image: kidslearning,
            youtubeLink: "https://youtube.com/playlist?list=PLaxSLMAewZheGnJsWiqIhrx-NL_WbiIP_&si=6cj0j1twFnSwQNBZ"
        },
    ];


    const blogPosts = [

        {
            id: 1,
            title: "How to Teach Kids Do's and Don'ts for Safety and Kindness:",
            description: "As children grow between ages 3-7, they begin exploring the world with curiosity and confidence. This is an exciting stage...",
            date: "07 January 2026",
            readTime: "4 min read",
            animal: "deer", // brown deer
            animalImg: deerImg, // Yahan image add karein

            image: null
        },
        {
            id: 2,
            title: "How to Teach Kids About Stranger Safety:",
            description: "As children grow between ages 3-7, they become more curious about the world around them. They begin exploring...",
            date: "07 January 2026",
            readTime: "4 min read",
            animal: "turtle", // green turtle
            animalImg: turtleImg, // Yahan image add karein
            image: null
        },
        {
            id: 3,
            title: "How to Teach Kids Not to Take What Is Not Theirs:",
            description: "Between ages 3-7, children are learning how the world works. They are curious, observant, and still developing self-control...",
            date: "07 January 2026",
            readTime: "4 min read",
            animal: "elephant2", // gray elephant
            animalImg: elephiImg, // Yahan image add karein
            image: null
        }
    ];

    const animalStyles = {
        elephant: { top: '-50px', left: '-80px', transform: 'scale(0.8)' },
        cow: { top: '-75px', left: '50%', transform: 'translateX(-50%) scale(0.7)' },
        lion: { top: '-80px', right: '-60px', transform: 'scale(0.8)' },
        deer: { top: '-85px', left: '-85px', transform: 'scale(0.75)' },
        turtle: { top: '-80px', left: '50%', transform: 'translateX(-50%) scale(0.7)' },
        elephant2: { top: '-70px', right: '-80px', transform: 'scale(0.8)' }
    };

    //share blogs function
    const handleShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: document.title,
                    // text: 'Is blog ko dekho ',
                    url: window.location.href,
                });
            } catch (err) {
                // user ne cancel kiya to kuch mat karo
            }
        } else {
            alert('Share supported nahi hai is browser me');
        }
    };



    const socialLinks = [
        { img: Linkdin, link: "https://www.linkedin.com/company/jungle-morals-entertainment/?viewAsMember=true" },
        { img: youtube, link: "https://www.youtube.com/channel/UCF4P0048BiT04m1ss61qpGA" },
        { img: facebook, link: "https://www.facebook.com/junglemorals/" },
        { img: instaIcon, link: "https://www.instagram.com/junglemorals/" },
        { img: Pinterest, link: "https://in.pinterest.com/junglemorals/" },
        { img: share, isShare: true },
    ];

    const TopCard = ({ title, img, onClick }) => (
        <div className="col-12 col-sm-6 col-md-4 col-lg">
            <div
                onClick={onClick}
                className="position-relative overflow-hidden"
                style={{ cursor: "pointer" }}
            >
                {/* Background image */}
                <img src={img} alt={title} className="img-fluid w-100" />

                {/* Overlay text */}
                <div
                    className={`position-absolute top-50 start-50 translate-middle fw-bold ${styles.usereff}`}

                >
                    {title}
                </div>
            </div>
        </div>
    );


    const challengeRef = useRef(null);
    const whatToDoRef = useRef(null);
    const whatNotRef = useRef(null);
    const activityRef = useRef(null);
    const watchRef = useRef(null);
    const newsletterRef = useRef(null);


    const scrollTo = (ref) => {
        ref.current.scrollIntoView({ behavior: "smooth" });
    };

    //for the margintop fix of page
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 585);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 585);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);



    //SEO meta information


    const [blog, setBlog] = useState(null);
    const [loading, setLoading] = useState(true);

    // useEffect(() => {
    //     // Fetch blogs from localStorage (same as admin dashboard)
    //     const blogs = JSON.parse(localStorage.getItem("adminBlogs"));

    //     if (blogs) {
    //         const currentBlog = blogs.find(b => b.slug === slug);
    //         setBlog(currentBlog);
    //     }

    //     setLoading(false);
    // }, [slug]);

    // if (loading) {
    //     return <div className="container py-5 text-center">Loading...</div>;
    // }

    // if (!blog) {
    //     return (
    //         <div className="container py-5">
    //             <div className="alert alert-danger">
    //                 <h4>Blog not found</h4>
    //                 <p>Sorry, the blog post you're looking for doesn't exist.</p>
    //             </div>
    //         </div>
    //     );
    // }


    return (

        <>
            <SEOHelmet blog={{
                title: "Helping Kids Learn Empathy Through Love and Kindness",
                metaTitle: "Helping Kids Learn Empathy | Jungle Morals",
                metaDescription: "Simple conversations and everyday moments..."
            }} />

            <div className="" style={{
                color: '#005d52',
                marginTop: isMobile ? '-62vh' : '-45vh',
                minHeight: '100vh',
                position: 'relative',
                overflow: 'hidden',

            }}>
                <div className="container py-3 py-md-5 col-md-10 text-start" style={{ maxWidth: '1300px' }}
                >

                    {/* Breadcrumb Path */}
                    <div className="path p-2 m-0 ps-0 mb-3 mb-md-2 d-flex flex-wrap align-items-center gap-2 font-brandon z-2">
                        <Link to={'/'} className="text-decoration-none text-reset pe-auto z-1">
                            <span className="path-element text-pr-black ff-roboto pe-auto">Home</span>
                        </Link>
                        <FaAngleDoubleRight className="fa-icons" style={{ fontSize: '12px' }} />
                        <Link to={'/blogs'} className="text-decoration-none text-reset z-1">
                            <span className="path-element text-pr-black ff-roboto">Blogs</span>
                        </Link>
                        <FaAngleDoubleRight className="fa-icons" style={{ fontSize: '12px' }} />
                        <span className="path-element">{currentBlog.title}</span>
                    </div>
                    {/* Main Heading */}
                    <h1 className={`font-brandon  display-1 fw-bold ${styles.mainh1} `} >
                        Helping Kids Learn How Important Teamwork Is
                    </h1>

                    {/* Subheading */}
                    <p className="font-brandon fs-3 lh-sm">
                        Simple conversations, everyday play, and a kids moral story that help children understand teamwork, working together, and how friendship makes everyone stronger.
                    </p>

                    {/* Social Links & Date Section */}
                    <div className="path p-2 m-0 ps-0  mb-md-2 d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-3 gap-sm-2">

                        {/* Social Icons */}
                        <div className="path-element text-muted ff-roboto d-flex align-items-center gap-3 order-2 order-sm-1">
                            {socialLinks.map((item, index) => (
                                <a
                                    key={index}
                                    href={item.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="d-inline-block"
                                >
                                    <img
                                        src={item.img}
                                        alt="social-icon"
                                        width="40"
                                        height="40"
                                        className="social-icon"
                                        style={{ objectFit: "contain", cursor: "pointer" }}
                                        onClick={() => {
                                            if (item.isShare) {
                                                handleShare();        // ✅ native share
                                            } else {
                                                window.open(item.link, '_blank'); // ✅ normal social links
                                            }
                                        }}

                                    />
                                </a>
                            ))}
                        </div>

                        {/* Date & Read Time */}
                        <div className="d-flex flex-row flex-sm-column align-items-start align-items-sm-end gap-2 gap-sm-1 order-1 order-sm-2 font-brandon">
                            <small className="text-nowrap" style={{ color: '#005d52', fontSize: '20px', fontWeight: "900" }}>
                                07 January 2026
                            </small>
                            <span className="d-inline d-sm-none text-muted">•</span>
                            <small className="text-nowrap" style={{ color: '#005d52', fontSize: '20px', fontWeight: "900" }}>
                                4 min read
                            </small>
                        </div>
                    </div>
                </div>



                <div className="container-fluid px-3 px-md-4" style={{ maxWidth: '1600px' }}
                >
                    <div className="row justify-content-center">
                        <div className="col-12 col-xl-10">
                            <div className={`row text-center g-2 g-md-3 font-brandon  ${styles.strongtext}`}>
                                <TopCard title="The Challenge" img={TheChallenge} onClick={() => scrollTo(challengeRef)} />
                                <TopCard title="What To Do" img={Whattodo} onClick={() => scrollTo(whatToDoRef)} />
                                <TopCard title="What NOT To Do" img={Whatnottodo} onClick={() => scrollTo(whatNotRef)} />
                                <TopCard title="Activity Card" img={activitycard} onClick={() => scrollTo(activityRef)} />
                                <TopCard title="Watch and Learn" img={whatchlearn} onClick={() => scrollTo(watchRef)} />
                            </div>
                        </div>
                    </div>
                </div>


                <section ref={challengeRef} className="container  col-md-10" style={{ maxWidth: '1300px' }}
                >
                    <div className="d-flex justify-content-center align-items-center flex-column">


                        <div
                            className="text-center board-wrapper"
                            style={{
                                backgroundImage: `url(${boardimg})`,
                                backgroundSize: 'contain',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                                position: 'relative',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '100%',
                                aspectRatio: '16 / 10',     // ⭐ key fix
                            }}
                        >
                            <img
                                src={thumbnail}
                                style={{
                                    width: '93%',
                                    height: '90%',
                                    objectFit: 'contain',
                                }}
                            />
                        </div>

                        <div className="">
                            <h2 className={`font-brandon   ${styles.strongtextheading} `}>Introduction</h2>
                            <p className="font-brandon fs-2 lh-sm mb-5">Between ages<strong className={styles.strongtext}> 3-7</strong>, children begin to move from independent play to cooperative play. They start learning that some things are easier and more fun when done together. At the same time, sharing ideas, taking turns, and listening to friends can feel challenging.</p>

                            <p className="font-brandon fs-2 lh-sm mb-4">Parents often look for ways to teach <strong className={styles.strongtext}>working together, teamwork</strong>, and <strong className={styles.strongtext}>friendship</strong> without forcing cooperation. When children understand that unity helps everyone succeed, collaboration becomes a positive choice rather than a rule.</p>


                            <p className="font-brandon fs-2 lh-sm">This week at Jungle Morals, we explore how children can work together, build strong friendships, and learn that unity truly is strength.  </p>
                        </div>

                    </div>
                </section>


                <section ref={challengeRef} className="container py-1 col-md-10 mt-5" style={{ maxWidth: '1300px' }}
                >
                    <h2 className={`font-brandon   ${styles.strongtextheading}`} >The Challenge</h2>
                    <p className="   fs-3 lh-sm mb-4 fst-italic">Why teamwork does not come naturally at first</p>
                    <p className="font-brandon fs-2 lh-sm mb-5">Young children are still learning perspective and cooperation. They may want things done their own way or feel frustrated when others think differently. Without guidance, children may avoid teamwork even when it would help.</p>
                    <div className="row align-items-center justify-content-center">
                        <div className="col-md-6">


                            <h5 className={`font-brandon fs-3  ${styles.strongtext} `}>Parents may notice children:</h5>
                            <ul className="font-brandon fs-2 lh-sm  ps-4.5 mb-5">
                                <li>wanting to do everything alone</li>
                                <li>getting upset during group activities</li>
                                <li>refusing to share ideas</li>
                                <li>struggling with turn taking</li>
                                <li>leaving group play</li>
                            </ul>

                            <h5 className={`font-brandon fs-3  ${styles.strongtext} `}>You may hear children say:</h5>
                            <ul className="font-brandon fs-2 lh-sm  ps-4.5 mb-5" >
                                <li>“I want to do it myself.”</li>
                                <li>“They are not listening.”</li>
                                <li>“I do not want to play together.”</li>
                                <li>“My way is better.”</li>
                            </ul>


                        </div>

                        <div className="col-md-6 text-center">
                            <img src={rabbit} className="img-fluid" alt="rabbit" width={"400"} />
                        </div>
                        <p className="font-brandon fs-2 lh-sm mb-5">These behaviours are common. Children between ages <strong className={styles.strongtext}> 3-7</strong> are still learning cooperation, communication, and how teamwork strengthens friendships.</p>

                        <p className="font-brandon fs-2 lh-sm mb-5">Small image on the right: a Jungle Morals group of friends working together.</p>


                    </div>
                </section>



                <section ref={whatToDoRef} className="container col-md-10 py-1" style={{ maxWidth: '1300px' }}
                >
                    <h2 className={`font-brandon  mb-3 ${styles.strongtextheading}`}>What To Do</h2>
                    <p className="font-brandon fs-3 lh-sm fst-italic">Gentle ways to help kids build teamwork and friendship:</p>
                    <div className="row align-items-center justify-content-center">
                        <div className="col-md-6">

                            <h5 className={`font-brandon fs-2  mt-2 ${styles.strongtext}`}>
                                <svg
                                    width="28"
                                    height="28"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                                        fill="#28a745"
                                        stroke="#28a745"
                                        strokeWidth="2.5"
                                    />
                                </svg>
                                Encourage shared goals</h5>
                            <ul className="font-brandon fs-3 lh-sm  list-unstyled ps-0">
                                <li>Help children work toward one outcome.</li>
                                <li>“Let us finish this together.”</li>
                            </ul>

                            <h5 className={`font-brandon fs-2 mt-4  ${styles.strongtext}`}>
                                <svg
                                    width="28"
                                    height="28"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                                        fill="#28a745"
                                        stroke="#28a745"
                                        strokeWidth="2.5"
                                    />
                                </svg>
                                Teach listening skills</h5>
                            <ul className="font-brandon fs-3 lh-sm  list-unstyled ps-0">
                                <li>Show the value of hearing others.</li>
                                <li>“What does your friend think?”</li>
                            </ul>

                            <h5 className={`font-brandon fs-2 mt-4 ${styles.strongtext}`}>
                                <svg
                                    width="28"
                                    height="28"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                                        fill="#28a745"
                                        stroke="#28a745"
                                        strokeWidth="2.5"
                                    />
                                </svg>
                                Celebrate group effort</h5>
                            <ul className="font-brandon fs-3 lh-sm  list-unstyled ps-0">
                                <li>Praise teamwork over individual success.</li>
                                <li>“You all worked as a team.”</li>
                            </ul>

                            <h5 className={`font-brandon fs-2 mt-4  ${styles.strongtext}`}>
                                <svg
                                    width="28"
                                    height="28"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                                        fill="#28a745"
                                        stroke="#28a745"
                                        strokeWidth="2.5"
                                    />
                                </svg>
                                Create cooperative activities</h5>
                            <ul className="font-brandon fs-3 lh-sm  list-unstyled ps-0">
                                <li>Choose games that require collaboration.</li>
                            </ul>

                            <h5 className={`font-brandon fs-2 mt-4  ${styles.strongtext}`}>
                                <svg
                                    width="28"
                                    height="28"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
                                        fill="#28a745"
                                        stroke="#28a745"
                                        strokeWidth="2.5"
                                    />
                                </svg>
                                Model teamwork</h5>
                            <ul className="font-brandon fs-3 lh-sm  list-unstyled ps-0">
                                <li>Children learn unity by watching adults work together.</li>
                            </ul>

                        </div>
                        <div className="col-md-6 text-center">
                            <img src={dog} className="img-fluid" alt="rabbit" width={"440"} />
                        </div>
                    </div>
                </section>


                <section ref={whatNotRef} className="container col-md-10 py-1 mt-3" style={{ maxWidth: '1300px' }}
                >
                    <h2 className={`font-brandon mb-3 ${styles.strongtextheading}`}>What NOT To Do</h2>
                    <p className="font-brandon fs-2 lh-sm mb-4 fst-italic">When teaching teamwork and unity, avoid these habits.</p>
                    <div className=" col-md-12">
                        <h5 className={`font-brandon fs-3 ${styles.strongtext} `}>Avoid:</h5>
                        <ul className="font-brandon fs-3 lh-sm  list-unstyled ps-0">
                            <li>
                                <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', marginBottom: "8px", verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M18 6L6 18M6 6l12 12"
                                        stroke="#dc3545"
                                        strokeWidth="4"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                Do not force cooperation</li>
                            <li>
                                <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', marginBottom: "8px", verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M18 6L6 18M6 6l12 12"
                                        stroke="#dc3545"
                                        strokeWidth="4"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>

                                Do not compare team members</li>
                            <li>

                                <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', marginBottom: "8px", verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M18 6L6 18M6 6l12 12"
                                        stroke="#dc3545"
                                        strokeWidth="4"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                Do not dismiss different ideas</li>
                            <li>

                                <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', marginBottom: "8px", verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M18 6L6 18M6 6l12 12"
                                        stroke="#dc3545"
                                        strokeWidth="4"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                Do not rush group problem solving</li>
                            <li>

                                <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ marginRight: '8px', marginBottom: "8px", verticalAlign: 'middle' }}
                                >
                                    <path
                                        d="M18 6L6 18M6 6l12 12"
                                        stroke="#dc3545"
                                        strokeWidth="4"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                Do not reward only individual wins</li>

                        </ul>
                        <p className="font-brandon fs-2 lh-sm mt-4">Unity grows when children feel valued and included.</p>
                        <p className="font-brandon fs-2 lh-sm mt-4 ">

                            <img src={bell} alt="" srcset="" width={"30px"} className="mb-2" />
                            Want weekly Jungle activities, updates, and more? <Link to="#"
                                onClick={(e) => {
                                    e.preventDefault();

                                    if (newsletterRef.current) {
                                        newsletterRef.current.scrollIntoView({
                                            behavior: "smooth",
                                            block: "center"
                                        });
                                    }
                                }}
                            > Join Our Newsletter!</Link>
                        </p>
                    </div>
                </section>


                <section ref={activityRef} className="container py-1 col-md-10 " style={{ maxWidth: '1300px' }}
                >
                    <h2 className={`font-brandon  ${styles.strongtextheading}`}>‘Family Fix-It’ Activity Card:</h2>
                    <p className="font-brandon fs-1 lh-sm fst-italic">A Fun Way to Teach Kids Teamwork and Working Together</p>

                    <div className="row my-4">
                        <div className="col-md-6">
                            <img src={activity1} className="img-fluid " />
                        </div>
                        <div className="col-md-6">
                            <img src={activity2} className="img-fluid " />
                        </div>
                    </div>
                    <p className="font-brandon fs-2 lh-sm fst-italic" >Why this activity works:
                        This activity helps children practise cooperation and understand how working together makes tasks easier and more enjoyable.</p>

                </section>


                <section ref={watchRef} className="container col-md-10 py-1 mt-3" style={{ maxWidth: '1300px' }}
                >
                    <h2 className={`font-brandon fs-1 ${styles.strongtext}`}>How parents should guide it</h2>
                    <ul className="font-brandon fs-3 lh-sm   ps-0.5">
                        <li>Do the activity together</li>
                        <li>Talk about teamwork moments </li>
                        <li>Encourage sharing ideas</li>
                    </ul>


                    <h2 className={`font-brandon fs-1 ${styles.strongtext}`}>What children learn:</h2>
                    <ul className="font-brandon fs-3 lh-sm   ps-0.5">
                        <li>Teamwork</li>
                        <li>Cooperation</li>
                        <li>Friendship</li>
                        <li>Unity</li>
                    </ul>




                    <div>

                        <div className="position-relative d-flex justify-content-center align-items-center my-4">
                            <Link to={"/form"} className="position-relative d-flex justify-content-center align-items-center my-4 text-reset">
                                <h3 className="position-absolute  fw-bold fs-3 grab-text text-center font-adventuring">
                                    Grab your free<br /> activity card
                                </h3>

                                {/* Board image */}
                                <img src={board} alt="Activity Board" className="img-fluid board-img" width={"350px"} />
                            </Link>
                        </div>


                        <h2 className={`font-brandon   ${styles.strongtextheading}`}>Watch This Week’s - Unity Is Strength</h2>
                        {/* Header Section */}
                        {/* Blog Cards Grid */}
                        <div className="row g-5">
                            {blogPost.map((post, index) => (
                                <div key={post.id} className="col-12 col-md-6 col-lg-4">
                                    <div
                                        className="card h-100"
                                        style={{
                                            border: 'none',
                                            cursor: 'pointer',
                                            transition: 'transform 0.3s ease'
                                        }}
                                        onClick={() => window.open(post.youtubeLink, '_blank')}
                                        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                    >
                                        {/* Card Image/Content Area */}
                                        <div style={{
                                            height: '240px',
                                            backgroundImage: `url(${boardimg})`,
                                            backgroundSize: 'contain',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat',
                                            position: 'relative',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '10px 10px'
                                        }}>
                                            <img
                                                src={post.image}
                                                alt={post.title}
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain',
                                                }}
                                            />
                                        </div>

                                        {/* Grass decoration */}
                                        <div style={{
                                            width: "50%",
                                            minHeight: "150px",
                                            height: "30vw",
                                            maxHeight: "100px",
                                            marginTop: "24%",
                                            position: 'absolute',
                                            marginLeft: "61%",
                                        }}>
                                            <img
                                                src={geassdivImg}
                                                alt="grass decoration"
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: "contain"
                                                }}
                                            />
                                        </div>

                                        <div className="card-body" style={{ padding: '1px' }}>
                                            <h5 className="card-title font-brandon fs-3 lh-sm" style={{
                                                color: '#005d52',
                                                fontWeight: 'bold',
                                                fontSize: '22px',
                                                marginBottom: '10px',
                                                textAlign: "center"
                                            }}>
                                                {post.title}
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>


                    </div>

                    <p className="font-brandon fs-2 lh-sm mb-1 mt-5">This animated kids moral story teaches:</p>
                    <ul className="font-brandon fs-3 lh-sm   ps-0.5" >
                        <li>working together</li>
                        <li>teamwork</li>
                        <li>friendship</li>
                        <li>unity is strength</li>
                    </ul>
                    <p className="font-brandon fs-2 lh-sm mb-4 mt-4">Kids love watching characters make small choices that lead to big learnings.</p>
                    <p className="font-brandon fs-2 lh-sm d-flex gap-2">

                        <img src={bell} alt="" srcset="" width={"30px"} className="mb-2  " />
                        <Link to={"https://www.youtube.com/channel/UCF4P0048BiT04m1ss61qpGA"} target="blank" >Watch more Jungle Morals stories on YouTube!</Link>
                    </p>

                    <h4 className={`font-brandon  mt-5 ${styles.strongtextheading}`}>Final Thoughts & Learnings</h4>
                    <ul className="font-brandon fs-3 lh-sm   ps-0.5">
                        <li>Children learn punctuality through habits, not pressure</li>
                        <li>Time awareness develops slowly between ages three to seven</li>
                        <li>Visual routines help children understand daily time flow</li>
                        <li>Gentle reminders work better than rushing or scolding</li>
                        <li>Preparation reduces morning stress and last-minute delays</li>
                        <li>Praising e ort builds responsibility and self-confidence</li>
                        <li>Play-based activities make time management easier to learn</li>
                        <li>Consistency turns small routines into lifelong punctual habits</li>
                    </ul>

                </section>


                <section className={styles.wisdomSection} style={{ maxWidth: '2900px' }}
                >
                    <div className="container-fluid px-0" style={{ maxWidth: '1600px' }} >
                        <div className="row align-items-center justify-content-start mx-0">
                            <div className={`col-auto text-center ${styles.elephantCol}`}>
                                <img
                                    src={finalElephant}
                                    className={`img-fluid ${styles.elephantImage}`}
                                    alt="elephant"
                                />
                            </div>
                            <div className="col text-start text-white ps-0 ps-sm-3 ps-md-4 ps-lg-2 mb-md-5 ">
                                <h4 className={`font-brandon  mb-1 ${styles.wisdomTitle}`}>Final Jungle Wisdom</h4>
                                <p className={`font-brandon  lh-sm mb-1 ${styles.wisdomText}`}>
                                    When children work together, their shared strength helps everyone succeed.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>




                <section className="container py-5 col-md-10 text-start d-flex justify-content-evenly flex-column" style={{ maxWidth: '1300px' }}
                >
                    <h2 className={`font-brandon mb-2 ${styles.strongtextheading}`}>Get Weekly Jungle Activities, Updates and More!</h2>
                    <p className="font-brandon fs-4 lh-sm">One simple activity and one gentle parenting tip every week.</p>



                    <div className="d-flex justify-content-center px-2" ref={newsletterRef}>

                        {/* Board Wrapper */}
                        <div
                            style={{
                                position: "relative",
                                width: "100%",
                                maxWidth: "450px"   //  desktop same, mobile shrink
                            }}
                        >
                            {/* Board Image */}
                            <img
                                src={weeklyActivity}
                                alt="Weekly Activity Board"
                                style={{
                                    width: "100%",
                                    height: "auto",
                                    display: "block"
                                }}
                            />

                            {/* CONTENT INSIDE BOARD */}
                            <div
                                style={{
                                    position: "absolute",
                                    top: "55%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    width: "75%",
                                    textAlign: "center"
                                }}
                            >
                                {/* Email Input */}
                                <input
                                    type="email"
                                    className="form-control mb-2 font-brandon"
                                    placeholder="Email ID"
                                    style={{
                                        borderRadius: "5px",
                                        border: "2px solid #9ec9bb",
                                        padding: "clamp(4px, 1vw, 6px) 14px",
                                        fontSize: "clamp(13px, 3vw, 15px)"
                                    }}
                                />

                                {/* Checkbox */}
                                <div className="form-check d-flex justify-content-center align-items-center">
                                    <input
                                        className="form-check-input me-2"
                                        type="checkbox"
                                        id="weeklyCheck"
                                        style={{
                                            border: "2px solid #2f6f62",
                                            transform: "scale(0.9)"
                                        }}
                                    />
                                    <label
                                        className="form-check-label  font-brandon fs-4 lh-sm"
                                        htmlFor="weeklyCheck"
                                        style={{
                                            color: "#2f6f62",
                                            fontSize: "clamp(12px, 3vw, 14px)",
                                            marginBottom: "-4px"
                                        }}
                                    >
                                        Send Me Weekly Activities!
                                    </label>
                                </div>

                                {/* Small text */}
                                <p
                                    className="text-reset font-brandon fs-6 lh-sm"
                                    style={{
                                        fontSize: "clamp(10px, 2.5vw, 12px)",
                                        marginBottom: "2px"
                                    }}
                                >
                                    We never spam. Unsubscribe anytime.
                                </p>

                                {/* Disclaimer */}
                                <p
                                    className="text-reset font-brandon"
                                    style={{
                                        fontSize: "clamp(9px, 2.2vw, 10px)",
                                        lineHeight: "1.3"
                                    }}
                                >
                                    By sharing your email address, you agree to receive marketing emails and
                                    consent to our{" "}
                                    <span className="text-decoration-underline">
                                        Terms and Conditions
                                    </span>{" "}
                                    and{" "}
                                    <span className="text-decoration-underline">
                                        Privacy Policy
                                    </span>.
                                </p>
                            </div>

                        </div>
                    </div>



                    {/* <div className="row align-items-center justify-content-center col-md-10">
                    <div className="col-md-4 text-center">
                        <img src={safiaElephant} width="320" />
                    </div>

                    <div className="col-md-8 text-start">
                        <h4 className="mt-3 font-brandon fs-1 fw-bold">Safia Bano</h4>
                        <p className="font-brandon fs-5 lh-sm">
                            As the author, I am proud to say that I have been recognized as a New York
                            Times best-selling author. My writing style has captivated audiences, and my
                            stories have received widespread acclaim.
                        </p>
                        <hr className="my-3" style={{
                            height: "2px",
                            backgroundColor: "#005d52",
                            border: "none",
                            opacity: 1
                        }} />
                        <div className="d-flex justify-content-start gap-3">
                            <Link to={"https://www.linkedin.com/company/jungle-morals-entertainment/?viewAsMember=true"} target="blank">
                                <img src={Linkdin} alt="" srcset="" width={"40"} height={"40"} />
                            </Link>

                            <Link to={"https://www.instagram.com/junglemorals/"} target="blank">
                                <img src={instaIcon} alt="" srcset="" width={"40"} height={"40"} />
                            </Link>

                        </div>
                    </div>
                </div> */}
                </section>


                <section className="container py-1 col-md-10" style={{ maxWidth: '1300px' }}
                >
                    <h3 className={`mt-3 font-brandon  ${styles.strongtextheading}`}>Similar Picks For You!</h3>
                    <div className="mt-5">
                        {/* Header Section */}
                        {/* Blog Cards Grid */}
                        <div className="row g-5 mt-5">
                            {blogPosts.map((post, index) => (
                                <div key={post.id} className="col-12 col-md-6 col-lg-4">
                                    <div className="card h-100" style={{ border: 'none' }}>
                                        {/* Animal Head - Sirf image dikhegi, background nahi */}
                                        <div style={{
                                            position: 'absolute',
                                            ...animalStyles[post.animal],
                                            width: '170px',  // Size badha diya
                                            height: '170px', // Size badha diya
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            zIndex: 10,
                                        }}>
                                            {/* Sirf animal image */}
                                            <img
                                                src={post.animalImg}
                                                alt={post.animal}
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain' // contain use karo taaki poora animal dikhe
                                                }}
                                            />
                                        </div>

                                        {/* Card Image/Content Area */}


                                        {/* Card Image/Content Area */}
                                        <div style={{
                                            height: '240px',
                                            backgroundImage: `url(${boardimg})`, // Board frame
                                            backgroundSize: 'contain',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat',
                                            position: 'relative',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: '10px 10px'
                                        }}>
                                            {/* Blog thumbnail image - Board ke andar fit hogi */}
                                            <img
                                                src={post.image}
                                                // alt={post.title}
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'contain', // Image ko board ke andar fit karega
                                                    // borderRadius: '4px'
                                                }}
                                            />
                                        </div>

                                        {/* Grass decoration on top of image */}
                                        <div style={{
                                            width: "50%",
                                            minHeight: "150px",   // mobile
                                            height: "30vw",       // responsive height
                                            maxHeight: "100px",
                                            marginTop: "24%",  // desktop limit
                                            position: 'absolute',
                                            marginLeft: "61%",  // desktop limit

                                        }}>
                                            <img
                                                src={geassdivImg}
                                                alt="grass decoration"
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: "contain"
                                                }}
                                                onError={(e) => {
                                                    console.log('Grass div image failed:', e);
                                                    console.log('Image path:', geassdivImg);
                                                }}
                                            />
                                        </div>

                                        <div className="card-body" style={{ padding: '1px' }}>
                                            <div className="d-flex justify-content-between align-items-center mb-2 font-brandon">
                                                <small style={{ color: ' #005d52', fontSize: '12px', fontWeight: "600" }}>{post.date}</small>
                                                <small style={{ color: ' #005d52', fontSize: '12px', fontWeight: "600" }}>{post.readTime}</small>
                                            </div>
                                            <h5 className="card-title font-brandon" style={{
                                                color: '#005d52',
                                                fontWeight: 'bold',
                                                fontSize: '22px',
                                                marginBottom: '10px'
                                            }}>
                                                {post.title}
                                            </h5>
                                            <p className="card-text font-brandon" style={{
                                                color: '#005d52',
                                                fontSize: '14px',
                                                lineHeight: '1.5',
                                                fontWeight: '400'
                                            }}>
                                                {post.description}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>


                    </div>
                </section>



            </div>
        </>
    );
};


export default HelpingKidsLearnHowImportantTeamworkIs;



